import { actionConstants } from './actionConstants';
import noti from './toast';
import { get, post, put, _delete } from './method';

export default {
  isLoadedCurrentUserPermissions,
  getCurrentUserPermissions,
  getPermissions,
  getPermissionsByRole,
  updatePermissions,
};

function isLoadedCurrentUserPermissions() {
  return (dispatch, getState) => {
    const { currentUserPermissions } = getState().permissions;
    return new Promise((resolve, reject) => {
      resolve(currentUserPermissions ? true : false);
    });
  };
}

function getCurrentUserPermissions() {
  return async (dispatch) => {
    return await get('app/permissions/current-user')
      .then((resp) => {
        const roleNames =
          JSON.parse(localStorage.getItem('userProfile')).roleNames || [];
        if (roleNames.length) {
          if (roleNames.includes('admin')) {
            resp.push('admin', 'Admin');
          } else {
            roleNames.forEach((role) => resp.push(role, role.toLowerCase()));
          }
        }
        dispatch({
          type: actionConstants.GET_CURRENT_USER_PERMISSIONS_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        // noti.error(error);
        dispatch({
          type: actionConstants.GET_CURRENT_USER_PERMISSIONS_FAILURE,
          data: error,
        });
        throw error;
      });
  };
}

function getPermissions() {
  return async (dispatch) => {
    return await get('app/permissions')
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_PERMISSIONS_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_PERMISSIONS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getPermissionsByRole(roleName) {
  return async (dispatch) => {
    return await get(`app/permissions/by-role/${roleName}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_PERMISSIONS_BY_ROLE_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_PERMISSIONS_BY_ROLE_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function updatePermissions(roleName, _params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    return await put(`app/permissions/by-role/${roleName}`, params)
      .then((resp) => {
        noti.success(`Permissions is added to ${roleName}`);
        dispatch({
          type: actionConstants.UPDATE_PERMISSIONS_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.UPDATE_PERMISSIONS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}
